<template>
  <NurseScheduleForm />
</template>

<script>
import NurseScheduleForm from "@/components/NurseScheduleForm.vue";

export default {
  components: {
    NurseScheduleForm
  }
};
</script>

<style></style>
